import { useEffect } from 'react';

import { useDocumentTitle } from 'hooks/document-title';
import ReactGA from 'react-ga4';

import { Error } from './Error';

const Error401 = () => {
  useDocumentTitle('Unauthorized | Checkmate');

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname,
      title: '401 Unauthorized',
    });
  }, []);

  return <Error message="Unauthorized Access">401</Error>;
};

export default Error401;
